import { chunk } from 'lodash';

interface IFormatCardExpirationDateParams {
  month: string;
  year: string;
}

export const formatCardExpirationDate = (params: IFormatCardExpirationDateParams): string => {
  const { month, year } = params;
  if (!month && !year) {
    return '';
  }
  return `${month}/${year}`;
};

export const formatCardNumber = (cardNumber: string) => chunk(cardNumber
  .replace(/\s/g, '')
  .split(''), 4)
  .map((part) => part.join('')).join(' ');

export const maskCardNumber = (
  cardLastDigits: string,
): string => `•••• •••• •••• ${cardLastDigits}`;

export const maskCVV = (cvv: string | null): string | null => {
  if (!cvv) {
    return null;
  }
  return cvv.replace(/\d/g, '•');
};
